import React from "react"
import classnames from "classnames"

import styles from "./styles.css"

const SharedDataSkeleton = () => {
  const mainSectionClasses = classnames(
    styles.mainSectionSkeleton,
    styles.whiteBackgroundSkeleton
  )
  const skeletonClasses = classnames(styles.skeletonCard, styles.skeleton)

  return (
    <div className={mainSectionClasses}>
      <div className={skeletonClasses}></div>
      <div className={skeletonClasses}></div>
    </div>
  )
}

export default SharedDataSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/SharedDataSkeleton/index.js